import { useSelector } from "react-redux"
import { type RootState } from "~Shared/store/rootState.interface"

export const useIsUserRightsReady = () => {
    const activeRights = useSelector(({ auth: { accessToken } }: RootState) => accessToken?.activeRights)

    return !!activeRights
}
